import styled, { css } from "styled-components";

import { ColumnContainer, Wrapper } from "@sso/ui/FlexBox";

import { DrawerList } from "./DrawerList";

const StyledSidebar = styled(ColumnContainer)`
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0.5rem;
  background: ${p => p.theme.colors.background.paper};
  color: ${p => p.theme.colors.grey.dark};
  width: ${p => p.theme.drawerWidth};
  height: calc(100vh - ${p => p.theme.headerHeight});

  overflow: auto;
  position: fixed;
  top: ${p => p.theme.headerHeight};
  left: 0;
  z-index: ${p => p.theme.zIndex.drawer};
  transition: all 0.3s;
  padding-top: 1.5rem;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    top: 0;
    height: 100vh;
    z-index: ${p => p.theme.zIndex.modal + 1};
    border-radius: 0 10px 10px 0;
    box-shadow: ${p => p.theme.shadows[10]};
  }

  transform: ${p => (p.open ? "translateX(0px)" : `translatex(-${p.theme.drawerWidth})`)};
`;

const StyledSidebarOverlay = styled(Wrapper)`
  display: none;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    display: initial;
    position: absolute;
    inset: 0;
    opacity: 0;
    background-color: ${p => p.theme.colors.common.black};
    z-index: ${props => props.theme.zIndex.negativeOne};
    transition: opacity 0.2s ease-out;
    opacity: 0;
    ${p =>
      p.open &&
      css`
        opacity: 0.6;
        z-index: ${p.theme.zIndex.modal + 1};
      `}
  }
`;

interface SidebarProps {
  drawerOpen: boolean;
  setDrawerToggle: () => void;
}
export const Sidebar = ({ drawerOpen, setDrawerToggle }: SidebarProps) => {
  return (
    <>
      <StyledSidebarOverlay open={drawerOpen} onClick={setDrawerToggle} />
      <StyledSidebar as="nav" open={drawerOpen}>
        <DrawerList />
      </StyledSidebar>
    </>
  );
};
